module.exports = __webpack_public_path__ + "static/img/104900.9fcb2315.png";